import { render, staticRenderFns } from "./AddObstetric.vue?vue&type=template&id=5e853dea&scoped=true"
import script from "./AddObstetric.vue?vue&type=script&lang=js"
export * from "./AddObstetric.vue?vue&type=script&lang=js"
import style0 from "./AddObstetric.vue?vue&type=style&index=0&id=5e853dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e853dea",
  null
  
)

export default component.exports